<template>
        <v-card class="elevation-10">
            <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs8></v-flex>
                        <v-flex xs2>
                            <v-btn :href="BASE + 'orders/export?search=' + search + '&sortBy=' + sortBy + '&order=' + order + '&download_token=' + download_token" target="_blank">Export</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="orders.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
                    v-on:update:pagination="ordenar"
            >
                <template slot="items" slot-scope="props">
                    <td @click="ver(props.item.id)">{{ props.item.concept }}</td>
                    <td @click="ver(props.item.id)" class="text-xs">{{ props.item.status.name }}</td>
                    <td @click="ver(props.item.id)" class="text-xs">{{ props.item.date }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="orders.data">
                <v-pagination
                        v-model="page"
                        :length="last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
            </div>
        </v-card>
</template>

<script>
    import { BASE } from '../../../config';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {sortBy: 'date', descending: true},
                loading: false,
                headers: [
                    {
                        text: 'Concept',
                        align: 'left',
                        sortable: true,
                        value: 'concept'
                    },
                    { text: 'Status', value: 'status_id', sortable: true },
                    { text: 'Date', value: 'date', sortable: true }
                ],
                orders: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                sortBy: 'concept',
                order: 'asc',
                BASE: BASE,
                download_token: null,
            }
        },
        created: function() {
            this.checkUser();
            this.getOrders();
            this.debouncedGetOrders = _.debounce(this.getOrders, 500)
        },
        computed : {
            active_client : function(){
                return this.$store.getters.getActiveClient;
            }
        },
        watch: {
            active_client: function() {
                this.getOrders();
            },
            search: function () {
                this.loading = true;
                this.debouncedGetOrders();
            },
            last_page: function () {
                if (this.page > this.orders.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getOrders();
            },
            ver(id) {
                this.$router.push({ name: 'agent.orders.detail', params : { id : id } });
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getOrders () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    }
                };
                this.$store.dispatch('getOrders', params).then((res) => {

                    this.orders = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/agent/orders/ListComponent.vue